module.exports = "./img/81fd6eb55206a5a2795e7fc776cc753b.jpg";